import { ScenarioInputs } from './types';

export const defaultScenario: ScenarioInputs = {
  meta: {
    name: 'Overengineered baseline'
  },
  general: {
    horizonYears: 30,
    annualReturnPct: 7,
    inflationPct: 4,
    inflationMode: 'real',
    retirementMode: true,
    endExitMode: 'FULL_EXIT_ALWAYS'
  },
  income: {
    monthlyIncome: 8500,
    incomeCurrency: 'EUR',
    fxRate: 4.3,
    lifeNeedMonthly: 13000,
    leakagePct: 3,
    bufferPct: 10
  },
  bookkeeping: {
    jdgBookkeeping: 300,
    spBookkeeping: 700,
    virtualOffice: 200,
    otherAdmin: 150
  },
  jdg: {
    ryczaltPct: 12,
    zusAsPercent: false,
    zusPercent: 30,
    zusFixed: 3500,
    capGainsTaxPct: 19,
    rebalance: 'annual',
    privateLeakagePct: 0
  },
  spzoo: {
    citMode: 'estonian',
    classicCITRatePct: 9,
    estonian: {
      useSimple: true,
      effectiveDistributionPct: 20,
      detailed: {
        estonianCITRatePct: 10,
        dividendPITPct: 19,
        pitOffsetPct: 5
      }
    },
    companyCapGainsTaxPct: 19,
    rebalance: 'annual',
    toolingSubsMonthly: 250,
    dividendTaxPct: 19,
    keepInCompany: false
  },
  owner: {
    solverEnabled: true,
    allowSalary: true,
    allowDividends: true,
    allowLoan: false,
    salaryPortionPct: 60,
    dividendPortionPct: 40,
    progressive: {
      threshold: 120000,
      lowerRatePct: 12,
      upperRatePct: 32,
      healthPct: 9
    },
    dividendTaxPct: 19,
    minSalaryGross: 7000,
    manualSalaryGross: 8000,
    manualDividendGross: 0,
    loan: {
      interestRatePct: 5,
      interestTaxPct: 19,
      termYears: 5,
      interestOnly: true,
      principalLimit: 120000,
      lumpSumAmount: 0,
      lumpSumYear: null,
      currency: 'PLN'
    },
    manualLoanDraw: 0
  }
};
